import React from "react";
import { IconButton, TablePagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CommonTable, { HeadCell } from "../../../../../business-types/grocery/components/CommonTable";
import ViewListIcon from "@mui/icons-material/ViewList";
import { CarOrder, CarOrderTableProps } from "../utils/types";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "src/business-types/grocery/hooks/tableConfig";

const CarOrderTable: React.FC<CarOrderTableProps> = ({
  orders,
  onRowClick,
  page,
  rowsPerPage,
  paginationData,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const navigate = useNavigate();

  const handleCustomerClick = (orderId: string | number) => {
    if (onRowClick) {
      onRowClick(orderId);
    } else {
      navigate(`/v1/car-order-details/${orderId}`);
    }
  };

  const headCells: HeadCell<CarOrder>[] = [
    { id: "SNo" as keyof CarOrder, label: "S.No" },
    { id: "CustomerName", label: "Name" },
    { id: "CustomerPhoneNo", label: "Phone Number" },
    { id: "Orderid", label: "Order ID" },
    { id: "OrderStatus", label: "Order Status" },
    { id: "Actions" as keyof CarOrder, label: "Actions" },
  ];

  const tableData: CarOrder[] = orders.map((order, index) => ({
    ...order,
    id: order.Orderid,
    SNo: index + 1,
    Actions: (
      <IconButton size="small" onClick={() => handleCustomerClick(order.Orderid)}>
        <ViewListIcon sx={{ color: "black" }} />
      </IconButton>
    ),
  }));

  return (
    <div className="thin-scrollbar w-full h-[72vh] overflow-y-auto">
      <CommonTable
        data={tableData}
        headCells={headCells}
        title=""
        pagenation={false}
        denseToggle={false}
        className="w-full"
        selectable={false}
      />

      {/* Pagination */}
      <div className="flex justify-end mr-8 mt-2">
        <TablePagination
          component="div"
          count={paginationData?.totalRecords || 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        />
      </div>
    </div>
  );
};

export default CarOrderTable;
